import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';

import { CustomSnackbarService } from 'src/app/shared/components/custom-snackbar/custom-snackbar.service';
import { FrodoService, HelmsdeepService } from 'src/app/shared/services';
import { TOAST_TYPES } from 'src/app/shared/utils/constants';

import { ERROR_MESSAGES } from './messages';
import * as actions from './spaces.actions';

@Injectable()
export class SpacesEffects {
  constructor(
    private actions$: Actions,
    private helmsdeepService: HelmsdeepService,
    private frodoService: FrodoService,
    private readonly customSnackbar: CustomSnackbarService
  ) {}

  loadSpaces$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadSpaces),
      switchMap(() =>
        this.helmsdeepService.getSpaces({ includeDispenses: true }).pipe(
          map((spaces) => actions.loadSpacesSuccess({ spaces })),
          catchError((error) => of(actions.loadSpacesFailure({ error })))
        )
      )
    )
  );

  openSpaceDoor$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.openSpaceDoor),
      mergeMap(({ spaceId }) =>
        this.frodoService.openSpaceDoor(spaceId).pipe(
          map(() => {
            return actions.openSpaceDoorSuccess();
          }),
          catchError(() => {
            this.customSnackbar.openSnackBar(
              ERROR_MESSAGES.UNABLE_TO_OPEN_SPACE_DOOR,
              TOAST_TYPES.Error
            );
            return of(actions.openSpaceDoorFailure());
          })
        )
      )
    )
  );
}
